var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{style:({
    zIndex: 1002,
  }),attrs:{"color":_vm.color,"multi-line":_vm.$vuetify.breakpoint.xsOnly,"auto-height":"","top":"","right":""},model:{value:(_vm.isVisible),callback:function ($$v) {_vm.isVisible=$$v},expression:"isVisible"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.message)}}),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","flat":""},on:{"click":_vm.handleClose}},[_c('v-icon',[_vm._v(" mdi-close-circle-outline ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }